import { render, staticRenderFns } from "./textDrr.vue?vue&type=template&id=75d87bf9&scoped=true&"
import script from "./textDrr.vue?vue&type=script&lang=js&"
export * from "./textDrr.vue?vue&type=script&lang=js&"
import style0 from "./textDrr.vue?vue&type=style&index=0&id=75d87bf9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d87bf9",
  null
  
)

export default component.exports